/*
 * Copyright (c) Dito Technologies
 */

import React from "react";
import styles from "ui/style/typography.module.scss";
import classnames from "classnames";

interface Props {
    children: React.ReactNode;
    className?: string;
}

const Body: React.FC<Props> = ({children, className}) => {
    return (
        <p className={classnames(styles.body, className)}>{children}</p>
    )
}

export default Body;